<template>
  <div>
    <h1>Company Roles</h1>
    <div class="line"></div>
    <br/>
    <div v-if="accountType === 'business'" class="create-section">
      <button type="button" class="btn create-btn d-flex flex-row" @click="createNewRole()">
        <img src="@/assets/img/icon-add.png" width="25px" height="25px">
        <h4><div class="create-btn-title">&nbsp;New Role</div></h4>
      </button>
    </div>

    <roles-list-view
      :toTitleCase="toTitleCase"
      :roles="roles"
      :editRole="editRole"
      :deleteRole="deleteRole"/>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import RolesListView from '@/components/listview/RolesListView'

// import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'

// const api = new APIService()
const auth = new AuthService()

export default {
  components: {
    RolesListView
  },
  data(){
    return {
      accountType: auth.getAccountType(),
      companyId: '',
      roles: [],
      isRequestInProgress: true
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'currentCompany'])
  },
  watch: {
    currentCompany(newVal, oldVal) {
      if(newVal.roles) this.setValues()
    }
  },
  mounted() {
    console.log('current Company: ', this.currentCompany)
    if(this.currentCompany.roles) this.setValues()
  },
  methods: {
    toTitleCase(str) {
      return str.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() });
    },
    setValues() {
      this.isRequestInProgress = false
      this.companyId = this.currentCompany.id
      this.roles = this.currentCompany.roles
      console.log('roles: ', this.roles)
    },
    createNewRole() {
      console.log('createNewRole')
    },
    editRole(e){
      console.log('editRole')
    },
    deleteRole(e) {
      console.log('deleteRole')
    }
  }
}

</script>

<styles>

</styles>



// WEBPACK FOOTER //
// src/containers/dashboard/Roles.vue